import { Classroom, Session } from "@models/ISchema";

export interface ClassroomCellData {
  label: string;
  isSpecial: boolean;
}

export const getUniqueClassroomsFromSessions = (
  sessions: Session[] = [],
  /**
   * Optional: Support for old bookings without multiple classrooms behavior
   */
  classroom?: Classroom,
): ClassroomCellData[] => {
  if (classroom) {
    return [
      {
        label: classroom?.name || "",
        isSpecial: !!classroom?.isSpecialTagValue,
      },
    ];
  }

  const classrooms = sessions?.flatMap(session => session?.classrooms ?? []);

  const uniqueClassrooms = Object.values(
    classrooms?.reduce((acc, classroom) => {
      if (classroom?.code && !acc[classroom.code]) {
        acc[classroom.code] = {
          label: classroom?.code,
          isSpecial: !!classroom?.isSpecialTagValue,
        };
      }

      return acc;
    }, {} as Record<string, ClassroomCellData>),
  );

  return uniqueClassrooms;
};
